import React from 'react';
import { footerLinks } from '../../data/mock';
import { Github, Twitter, Linkedin } from 'lucide-react';
import { Link } from 'react-router-dom';
import LogoFull from '../ui/logo-full';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-neutral-200">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Main Footer */}
        <div className="py-12 md:py-20 flex flex-col md:flex-row items-center md:items-start justify-between gap-8">
          {/* Brand Column */}
          <div className="text-center md:text-left">
            <Link to="/" className="flex items-center justify-center md:justify-start gap-3 mb-4">
              <LogoFull />
            </Link>
            <p className="text-neutral-500 text-sm leading-relaxed max-w-xs">
              The definitive hiring platform. Intelligence that understands. Precision that delivers.
            </p>
          </div>

          {/* Social Media Icons - Right Side */}
          {/* <div className="flex items-center gap-3">
            <a href="#" className="w-10 h-10 bg-neutral-100 rounded-lg flex items-center justify-center hover:bg-black hover:text-white transition-all duration-300">
              <Twitter className="w-4 h-4" />
            </a>
            <a href="#" className="w-10 h-10 bg-neutral-100 rounded-lg flex items-center justify-center hover:bg-black hover:text-white transition-all duration-300">
              <Linkedin className="w-4 h-4" />
            </a>
            <a href="#" className="w-10 h-10 bg-neutral-100 rounded-lg flex items-center justify-center hover:bg-black hover:text-white transition-all duration-300">
              <Github className="w-4 h-4" />
            </a>
          </div> */}
        </div>

        {/* Bottom Bar */}
        <div className="py-6 border-t border-neutral-200 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-neutral-400 text-sm">
            © 2026 Sandgen. Brought to you by <a href="https://www.redsage.global" target="_blank" rel="noopener noreferrer" className="hover:text-black transition-colors">Redsage Global</a>
          </p>
          <div className="flex items-center gap-8">
            <a href="https://www.redsage.global/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-neutral-400 hover:text-black text-sm transition-colors">
              Privacy
            </a>
            <a href="https://www.redsage.global/terms-of-service" target="_blank" rel="noopener noreferrer" className="text-neutral-400 hover:text-black text-sm transition-colors">
              Terms
            </a>
        
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
